// The staff side of the one Better Auth client (features/auth/session.ts): the session narrowed
// to a staff user, for the one question the API's 403 totp_required leaves open — enrol, or
// sign in again with a code?
import { authClient } from "@/features/auth/session";

export type StaffTotpState = "signed-out" | "not-enrolled" | "enrolled";

export async function staffTotpState(): Promise<StaffTotpState> {
  const { data } = await authClient.getSession();
  if (!data || data.user.kind !== "staff") return "signed-out";
  return data.user.twoFactorEnabled ? "enrolled" : "not-enrolled";
}
